const dateElem = document.getElementById('p-product-delivery-date');
const dateFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

function calcDeliveryDate(){
    const daysToAdd = dateElem.dataset.days || 3;
    const today = new Date();
    const deliveryDate = new Date(today.getTime() + daysToAdd * 24 * 60 * 60 * 1000)

    // Check if the delivery date is a Sunday
    if (deliveryDate.getDay() === 0) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

  return deliveryDate.toLocaleDateString("de-DE", dateFormatOptions);
}

document.addEventListener('DOMContentLoaded', function() {
    dateElem.innerHTML = `Lieferung bis: ${calcDeliveryDate()}`;
  });